export default __webpack_public_path__ + "static/media/discord.4732aff7.png";